import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2, AlertTriangle } from "lucide-react";
import { BrandMark } from "@/components/politics/brand";
import { API, useAuth, googleRedirectUri } from "@/admin/AuthContext";

export default function AuthCallback() {
  const { refresh } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");
    const expectedState = sessionStorage.getItem("google_oauth_state");
    sessionStorage.removeItem("google_oauth_state");
    window.history.replaceState(null, "", window.location.pathname);

    if (params.get("error")) {
      setError("O login com Google foi cancelado ou negado.");
      return;
    }
    if (!code) {
      setError("Não recebemos o código de autorização do Google.");
      return;
    }
    if (!state || state !== expectedState) {
      setError("Sessão de login inválida. Tente novamente.");
      return;
    }

    axios
      .post(
        `${API}/auth/google/callback`,
        { code, redirect_uri: googleRedirectUri() },
        { withCredentials: true },
      )
      .then(async () => {
        await refresh();
        navigate("/admin", { replace: true });
      })
      .catch((err) => {
        const detail = err?.response?.data?.detail;
        setError(typeof detail === "string" ? detail : "Falha ao autenticar.");
      });
  }, [navigate, refresh]);

  return (
    <main className="min-h-screen bg-[#F5FAFB] grid place-items-center px-6">
      {error ? (
        <div
          data-testid="auth-callback-error"
          className="max-w-md text-center rounded-2xl border border-[#D94A0A]/30 bg-white p-8"
        >
          <div className="mx-auto grid h-12 w-12 place-items-center rounded-full bg-[#D94A0A]/12 text-[#D94A0A]">
            <AlertTriangle size={20} />
          </div>
          <h1 className="mt-4 font-display text-2xl font-bold text-[#1B1D1D]">
            Não conseguimos autenticar
          </h1>
          <p className="mt-3 text-sm text-[#51565F]">{error}</p>
          <button
            onClick={() => navigate("/admin/login", { replace: true })}
            data-testid="auth-callback-back-login"
            className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#1B1D1D] px-5 py-2.5 text-sm font-medium text-white hover:bg-[#208BFF] transition-colors"
          >
            Voltar ao login
          </button>
        </div>
      ) : (
        <div
          data-testid="auth-callback-loading"
          className="flex flex-col items-center gap-4 text-[#51565F]"
        >
          <BrandMark size={40} color="#208BFF" />
          <Loader2 size={20} className="animate-spin text-[#208BFF]" />
          <span className="text-sm">Autenticando…</span>
        </div>
      )}
    </main>
  );
}
